import ContractTaxiDriverAddResponse from "../../../../api/raily/contracts/taxi-driver/add/contracts-taxi-driver-add.response";
import ContractsTaxiDriverAdd from "./contracts-taxi-driver-add";

const create = (
  response: ContractTaxiDriverAddResponse,
): ContractsTaxiDriverAdd => {
  return {
    id: response.data.id,
  };
};

const contractsTaxiDriverAddFactory = {
  create,
};

export default contractsTaxiDriverAddFactory;
